<!-- @format -->

<sis-description-list>
  <dl>
    <ng-template #listItem>
      <dt class="sis-label">{{ "PROFILE.ATTAINED_DEGREES" | translate }}</dt>
      @if (degreeProgrammeAttainments.length) {
        <dd>
          <ul class="no-list-style-type">
            @for (attainment of degreeProgrammeAttainments; track attainment) {
              <li data-cy="study-right-attained-degree-title">
                {{ attainment.degreeTitleUrn | codeLocalizedName | async }}
                @if (attainment.attainmentDate; as graduationDate) {
                  , {{ graduationDate | localDateFormat }}
                }
                <sis-icon icon="achievement" color="success" />
              </li>
            }
          </ul>
        </dd>
      }
      @if (!degreeProgrammeAttainments.length) {
        <dd>{{ "PROFILE.NO_ATTAINED_DEGREES" | translate }}</dd>
      }
    </ng-template>
  </dl>
</sis-description-list>
